__turbopack_context__.v({
  "checkbox__container": "styles-module-scss-module__lps4wW__checkbox__container",
  "checkbox__container__modReverse": "styles-module-scss-module__lps4wW__checkbox__container__modReverse",
  "checkbox__wrapper": "styles-module-scss-module__lps4wW__checkbox__wrapper",
  "reverse": "styles-module-scss-module__lps4wW__reverse",
});
